export default {
      id: "reusable-heart-usage",
      viewBox: "0 0 51 50",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#reusable-heart",
      toString: function () {
        return this.url;
      }
    }